document.addEventListener("DOMContentLoaded", function () {
  function checkAndSetCookie() {
    let modalCookieName = "bubble-modal",
        modal = document.querySelector('.modal--container'),
        modalClose = modal ? modal.querySelector('.modal--close') : null,
        modalHideClass = 'modal--hide';

    if (!modal || !modalClose) {
      console.error('Modal or modal close button not found!');
      return;
    }

    modalLoad();

    function modalSetCookie(cname, cvalue, exdays) {
      let d = new Date();
      d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
      let expires = "expires=" + d.toUTCString();
      document.cookie = `${cname}=${cvalue};${expires};path=/`;
    }

    function modalGetCookie(cname) {
      let name = cname + "=";
      let ca = document.cookie.split(';');
      for (let i = 0; i < ca.length; i++) {
        let c = ca[i].trim();
        if (c.indexOf(name) === 0) {
          return c.substring(name.length, c.length);
        }
      }
      return "";
    }

    function modalHide() {
      modal.classList.add(modalHideClass); // Hide modal
      modalSetCookie(modalCookieName, "hide", 365); // Set cookie to remember
    }

    function modalShow() {
      modal.classList.remove(modalHideClass); // Show modal
    }

    function modalLoad() {
      // Check if the cookie is set to "hide"
      let modalPass = modalGetCookie(modalCookieName);
      let miniModalWrapper = document.querySelector('.mini-modal');
      let isHomepage = miniModalWrapper && miniModalWrapper.getAttribute('data-page-type') === 'index';

      if (modalPass === "hide" && !isHomepage) {
        // Do nothing — leave the modal hidden
        modal.classList.add(modalHideClass); // Ensure the class is there if cookie exists
      } else {
        modalShow(); // Show the modal
      }
    }

    // Add click event listener to the close button
    modalClose.addEventListener('click', function (e) {
      e.preventDefault();
      modalHide(); // Hide the modal and set the cookie
    });
  }

  checkAndSetCookie();
});
